import { Injectable } from '@angular/core';
import { HttpService } from 'libs/shared/services';
import { environment } from 'libs/environment';
import { IUnitOfMeasure } from 'libs/models/material-management/unit-of-measure.model';

@Injectable({ providedIn: 'root' })
export class UnitOfMeasureService {

  constructor(private http: HttpService) { }

  getUoM() {
    return this.http.Get<IUnitOfMeasure[]>(`${environment.baseUrl}/api/UnitMeasure/UnitForPricingInfo`);
  }

  getDensityUoM() {
    return this.http.Get<IUnitOfMeasure[]>(`${environment.baseUrl}/api/UnitMeasure/UnitDensityInfo`);
  }
}
